<template>
  <button type="button" class="default-button" :class="[{ disabled }, type]">
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: 'Button',
  props: {
    disabled: Boolean,
    type: {
      type: String,
      default: 'primary',
    },
  },
};
</script>
<style lang="scss" scoped>
.default-button {
  background: linear-gradient(90deg, #D25000 0%, #FF6E00 100%);
  color: #ffffff;
  cursor: pointer;
  min-width: 150px;
  height: 44px;
  border: 0;
  border-radius: 22px;
  font-size: 19px;
  font-weight: bold;
  letter-spacing: 0.1px;
  padding: 14px 15px 16px;
  white-space: nowrap;
  font-style: normal;
  line-height: 1;
  transition: all 500ms;

  @media print, screen and (max-width: 320px) {
    min-width: 125px;
  }

  &.secondary {
    background: red;
    font-weight: normal;
    @media print, screen and (max-width: 425px) {
      font-size: 14px;
      padding: 10px 5px 12px;
      min-width: 100px;
    }
    @media print, screen and (max-width: 320px) {
      height: 30px;
    }
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
</style>
